<template>
  <div
    v-if="whitelabel.omDesign"
    class="omk-checkbox-container"
    :class="{ 'flex-column': flexColumn }"
  >
    <omk-checkbox
      @click="handleClick"
      :checked="localValue"
      :disabled="disabled"
      :readonly="readonly"
      :custom-validation-message="errors[0]"
      :always-show-validation-message="errors.length > 0 && !localValue"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @keypress="$emit('keypress', $event)"
    >
      {{ label }}
      <a
        v-if="checkboxLink"
        tabindex="0"
        class="omk-inline-link"
        omk
        :href="checkboxLink"
        download
        @click.stop
        >{{ checkboxLinkText }}</a
      >
    </omk-checkbox>
  </div>

  <v-checkbox
    v-else
    :label="label"
    color="primary"
    :input-value="localValue"
    @change="handleVCheckboxChange"
    :disabled="disabled"
    :readonly="readonly"
    :error-messages="errors"
  />
</template>

<script>
  export default {
    name: 'Checkbox',
    inheritAttrs: false,
    props: {
      value: {
        type: [String, Number, Boolean],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      prefix: {
        type: String,
        default: '',
      },
      suffix: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      outlined: {
        type: Boolean,
        default: false,
      },
      dense: {
        type: Boolean,
        default: true,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
      autocomplete: {
        type: String,
        default: 'off',
      },
      hint: {
        type: String,
        default: '',
      },
      persistentHint: {
        type: Boolean,
        default: false,
      },
      customClass: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        required: false,
      },
      errors: {
        type: Array,
        default: () => [],
      },
      isDateField: {
        type: Boolean,
        default: false,
      },
      remainderOfEstateMargin: {
        type: Boolean,
        default: false,
      },
      max: {
        type: Number,
        default: null,
      },
      items: {
        type: Array,
        default: () => [],
      },
      group: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'primary',
      },
      activeClass: {
        type: String,
        default: '',
      },
      className: {
        type: String,
        default: '',
      },
      flexColumn: {
        type: Boolean,
        default: false,
      },
      checkboxLink: {
        type: String,
        default: '',
      },
      checkboxLinkText: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        localValue: this.value,
      };
    },
    watch: {
      value(newVal) {
        this.localValue = newVal;
      },
    },
    methods: {
      handleClick(event) {
        event.preventDefault();
        // omk-checkbox re-dispatches a synthetic click on the host when its
        // label area is clicked. Without this guard the user's real click and
        // the synthetic one each toggle localValue, leaving the parent's
        // v-model unchanged while the web component's own internal state
        // shows as ticked.
        if (!event.isTrusted) return;
        if (this.disabled || this.readonly) return;
        const newValue = !this.localValue;
        this.localValue = newValue;
        this.$emit('input', newValue);
        this.$emit('change', newValue);
      },
      handleVCheckboxChange(value) {
        if (this.disabled || this.readonly) return;
        this.localValue = value;
        this.$emit('input', value);
        this.$emit('change', value);
      },
      handleChange(event) {
        let value = event.target ? event.target.value : event;

        if (value === 'true') {
          value = true;
        } else if (value === 'on') {
          value = false;
        }

        this.localValue = value;
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .omk-checkbox-container {
    margin: 24px 0;
    &.flex-column {
      display: flex;
      flex-direction: column;
    }
  }

  .world-wide-choice {
    width: 100%;
    border-radius: 6px;
    font-weight: bold;
    margin-right: 0;
    margin-bottom: 5px;
    padding: 15px;
  }
</style>
